import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';
import ComboUnidadNegocio from "../componentes/ComboUnidadNegocio";


const useStyles = makeStyles((theme) => ({
    area: {display: 'inline-block', width: 200, marginLeft: 8},
    area_d: {display: 'inline-block', width: 400, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_area = values.area

    if (w_area===undefined) {
        errors.area = ['El campo Código es requerido'];
    }else {
        if (w_area === null) {
            errors.area = ['El campo Código es requerido'];
        } else {
            w_area = w_area.trim()
            if (w_area === '') {
                errors.area = ['El campo Código es requerido'];
            }
        }
    }


    var w_area_d = values.area_d

    if (w_area_d===undefined) {
        errors.area_d = ['El campo Descripcion es requerido'];
    }else {
        if (w_area_d === null) {
            errors.area_d = ['El campo Descripcion es requerido'];
        } else {
            w_area_d = w_area_d.trim()
            if (w_area_d === '') {
                errors.area_d = ['El campo Descripcion es requerido'];
            }
        }
    }


    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/UnidadArea`;

const UnidadAreaCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Unidad Area</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS UNIDAD AREA">

                    <ComboUnidadNegocio readOnly={false}  />

                    <TextInput
                        label="Código Unidad Area"
                        source="area"
                        formClassName={classes.area}
                        placeholder="Ingrese Código Unidad Area"
                        helperText="Código"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                    <TextInput
                        id="standard-full-width"
                        label="Descripción Unidad Area"
                        source="area_d"
                        formClassName={classes.area_d}
                        multiline
                        placeholder="Ingrese Descripcion Unidad Area"
                        helperText="Descripcion"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default UnidadAreaCreate;


